// For manage routes of Pages
import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import Help from "@/views/Help.vue";
import Application from "@/views/Profile/Application.vue";
import Registration from "@/views/Auths/Registration.vue";
import SignIn from "@/views/Auths/SignIn.vue";
import Login from "@/views/Auths/Login.vue";
import NotFound from "@/views/Error/NotFound.vue";
import UnAuthorized from "@/views/Error/UnAuthorized.vue";
import HelloSign from "@/views/Profile/HelloSign.vue";
import ForgotUsername from "@/views/Auths/ForgotUsername.vue";
import ForgotPassword from "@/views/Auths/ForgotPassword.vue";
import ResetPassword from "@/views/Auths/ResetPassword.vue";
import ChangeSettings from "@/views/Auths/ChangeSettings.vue";
import AuthorizationList from "@/views/Authorization/AuthorizationList.vue";
import CreateSubSequent from "@/views/Authorization/CreateSubSequent.vue";
import CreateAuthorization from "@/views/Authorization/CreateAuthorization.vue";
import ClaimList from "@/views/Claim/ClaimList.vue";
import UpdateProfile from "@/views/Profile/UpdateProfile.vue";
import CaseList from "@/views/Case/CaseList.vue";
import AcceptDecline from "@/views/Case/AcceptDecline.vue";
import Constants from "./constants.ts";
const routes = [
  {
    path: "/",
    redirect:'sign-in',
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: SignIn,
    meta: {
      title: "SignIn",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
        next({ path: '/home' })
       }else{
         next()
       }
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "Home",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/help_information",
    name: "Help",
    component: Help,
    meta: {
      title: "Help Information",
    },
  },
  {
    path: "/case_confirmation/:data",
    name: "AcceptDecline",
    component: AcceptDecline,
    meta: {
      title: "AcceptDecline",
    },
  },
  {
    path: "/application",
    name: "Application",
    component: Application,
    meta: {
      title: "Application",
    },
  },
  {
    path: "/change-settings",
    name: "ChangeSettings",
    component: ChangeSettings,
    meta: {
      title: "User Settings",
    },
     beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/cases",
    name: "Cases",
    component: CaseList,
    meta: {
      title: "Cases",
    },
     beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/claims",
    name: "Claims",
    component: ClaimList,
    meta: {
      title: "Claims",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/update-profile/:id",
    name: "UpdateProfile",
    component: UpdateProfile,
    meta: {
      title: "UpdateProfile",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/authorizations",
    name: "Authorizations",
    component: AuthorizationList,
    meta: {
      title: "Authorization Requests",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/create-authorization",
    name: "CreateAuthorization",
    component: CreateAuthorization,
    meta: {
      title: "CreateAuthorization",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/view-request/:id",
    name: "ViewAuthorization",
    component: CreateSubSequent,
    meta: {
      title: "ViewAuthorization",
    },
    beforeEnter: (to, from, next) => {
      let logged_data=localStorage.getItem('att_data');
       if(logged_data!=null){
         next()
       }else{
        next({ path: '/unauthorized' })
       }
    }
  },
  {
    path: "/register",
    name: "Registration",
    component: Registration,
    meta: {
      title: "Registration",
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "ForgotPassword",
    },
  },
  {
    path: "/forgot-username",
    name: "ForgotUsername",
    component: ForgotUsername,
    meta: {
      title: "ForgotUsername",
    },
  },
  {
    path: "/reset-password/:id",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      title: "ResetPassword",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login",
    },
  },
  {
    path: "/signing",
    name: "HelloSign",
    component: HelloSign,
    meta: {
      title: "Signing",
    },
  },
  {
    path: "/unauthorized",
    name: "UnAuthorized",
    component: UnAuthorized,
    meta: {
      title: "UnAuthorized",
    },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
    meta: {
      title: "404",
    },
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || Constants.documentTitle;
  next();
});
router.afterEach((to,from) => {
  localStorage.setItem("LS_ROUTE_KEY", from.name);
});
export default router;
